export const listProducerUserReportees = /* GraphQL */ `
  query listProducerUserReportees($filter: ModelProducerUserFilterInput) {
    listProducerUsers(filter: $filter) {
      items {
        userId
        userRole
        firstName
        lastName
        id
      }
    }
  }
`;

export const listProducerUsers = /* GraphQL */ `
  query listProducerUsers(
    $filter: ModelProducerUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducerUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        email
        firstName
        id
        lastName
        middleName
        phoneNumber
        userId
        userRole
        channelType
        reportingTo
        reportingToL2
        contactAddress {
          addrLine1
          addrLine2
          city
          state
          postCode
          latitude
          longitude
        }
      }
      nextToken
    }
  }
`;

export const getProducerUser = /* GraphQL */ `
  query getProducerUser($userId: ID!) {
    getProducerUser(userId: $userId) {
      email
      firstName
      id
      lastName
      middleName
      phoneNumber
      userId
      userRole
      channelType
      profileImage
      reportingTo
      reportingToL2
      totalChannelLevels
      userLevel
      contactAddress {
        addrLine1
        addrLine2
        city
        state
        postCode
        latitude
        longitude
      }
    }
  }
`;

export const listProducerProspects = /* GraphQL */ `
  query listProducerProspects(
    $filter: ModelProducerProspectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducerProspects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        city
        email
        lastName
        merchantName
        storeName
        middleName
        phoneNumber
        producerUserId
        prospectState
        createdAt
        updatedAt
        city
        addrLine1
        addrLine2
        postCode
        reportingTo
        prospectPhotos
        prospectStatus
        createdAt
        prospectDate
        updatedAt
        notes{
          userId
          message
          updatedAt
         }
      }
      nextToken
     
    }
  }
`;

export const getCustomerProfile = /* GraphQL */ `
  query getCustomerProfile($userId: ID!) {
    getCustomerProfile(userId: $userId) {
      id
      phoneNumber
      firstName
      lastName
      middleName
      email
      userId
      profileImage
      deliveryToId
    }
  }
`;

export const getCustomerPaymentByCustomerProfileId = /* GraphQL */ `
  query CustomerPaymentByCustomerProfileId($userId: ID!) {
    CustomerPaymentByCustomerProfileId(userId: $userId) {
      items {
        id
        cardHolderName
        cardNumber
        expDate
        postalCode
        cardDefault
        userId
      }
    }
  }
`;

export const getCustomerContacts = /* GraphQL */ `
  query CustomerContactsByCustomerProfileId(
    $userId: ID!
    $filter: ModelCustomerContactFilterInput
  ) {
    CustomerContactsByCustomerProfileId(userId: $userId, filter: $filter) {
      items {
        id
        contactCategory
        contactCustomType
        firstName
        lastName
        middleName
        phoneNumber
        email
        deliveryAddress {
          items {
            id
            addrLine1
            addrLine2
            addressType
            firstName
            city
            instructions
            lastName
            markDefault
            middleName
            phoneNumber
            postCode
            addrState
            customType
            country
          }
        }
        occasions {
          items {
            occasionDate
            occasionTitle
            reminder
            id
          }
        }
      }
    }
  }
`;

export const getCustomerOccasions = /* GraphQL */ `
  query CustomerOccasionByCustomerContactId($id: ID!) {
    CustomerOccasionByCustomerContactId(id: $id) {
      items {
        id
        occasionTitle
        occasionDate
        reminder
        customerContactId
      }
    }
  }
`;
export const getCustomerAddresses = /* GraphQL */ `
  query CustomerAddressByCustomerContactId($id: ID!) {
    CustomerAddressByCustomerContactId(id: $id) {
      items {
        id
        instructions
        addrLine1
        addrLine2
        addressType
        city
        firstName
        lastName
        phoneNumber
        middleName
        postCode
        addrState
        markDefault
      }
    }
  }
`;
export const getS3SignedURL = /* GraphQL */ `
  query getS3SignedURL(
    $contentType: String!
    $fileName: String!
    $userId: String!
    $requestType: String!
  ) {
    getS3SignedURL(
      contentType: $contentType
      fileName: $fileName
      userId: $userId
      requestType: $requestType
    ) {
      fileName
      signedURL
    }
  }
`;

export const searchAddress = /* GraphQL */ `
  query searchAddress($input: SearchAddressInput!) {
    searchAddress(input: $input) {
      items {
        city
        entries
        secondary
        state
        street_line
        zipcode
      }
    }
  }
`;
export const getMultipleSignedURL = /* GraphQL */ `
  query getMultipleSignedURL(
    $filesList: [S3FileType]!
    $reportingTo: String!
    $requestType: String!
    $prospectId: String
  ) {
    getMultipleSignedURL(
      filesList: $filesList
      reportingTo: $reportingTo
      requestType: $requestType
      prospectId: $prospectId
    ) {
      items {
        fileName
        signedURL
      }
    }
  }
`;